import React, { useEffect, useState } from 'react';
import MainMenuUI from '../components/main-menu/main-menu-ui';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import CoreBreadcrumbs from '../cvp-webgames-core/Components/ui/react/core-breadcrumbs';
import CoreCards from '../cvp-webgames-core/Components/ui/react/core-cards';
import CoreCarousel from '../cvp-webgames-core/Components/ui/react/core-carousel';
import CoreDemoScenario from '../cvp-webgames-core/Components/ui/react/core-controlled/demo-scenario/core-demo-scenario';
import CoreGeneralButton2, { GeneralButton2Type } from '../cvp-webgames-core/Components/ui/react/core-general-button2';
import CoreGeneralButton3, { GeneralButton3Type } from '../cvp-webgames-core/Components/ui/react/core-general-button3';
import CoreGeneralButton4, { GeneralButton4Type } from '../cvp-webgames-core/Components/ui/react/core-general-button4';
import CoreLandingPage from '../cvp-webgames-core/Components/ui/react/core-landing-page';
import CoreLoadingAnimation, { CoreLoadingAnimationLoadingType } from '../cvp-webgames-core/Components/ui/react/core-loading-animation';
import GameManager from '../cvp-webgames-core/GameManager';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import { setUp508, PageType, setFocus, updateLast508Window } from '../misc/tools';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import Scenario1 from '../scenarios/scenario1';
import Scenario2 from '../scenarios/scenario2';
import Scenario5 from '../scenarios/scenario5';
import Scenario3 from '../scenarios/scenario3';
import Scenario4 from '../scenarios/scenario4';
import { PrecacheItemType } from '../cvp-webgames-core/pre-caching/pre-cache-item';

export enum MainMenuWindow508Type {
	Main,
	ReturnToMainMenu,
	SimpleAccessibility,
	AlertUI,
}

let current508Window = MainMenuWindow508Type.Main;

let windows508Layers: any[] = []
const objectWindowIDs = {
    main: {
        objects: [
            'main-content-top',
            // 'main-content-bottom',
        ]
    },
    returnToMainMenu: {
        objects: [
            'return-to-main-menu-content-top',
			'return-to-main-menu-content-bottom',
        ]
    },
    simpleAccessibility: {
        objects: [
            'simple-accessibility-content-top',
            'simple-accessibility-content-bottom',
        ]
    },
    alert: {
        objects: [
            'alert-content-top',
            'alert-content-bottom',
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[MainMenuWindow508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };
	windows508Layers[MainMenuWindow508Type.ReturnToMainMenu] = {
        objects: objectWindowIDs.returnToMainMenu.objects
    };
	windows508Layers[MainMenuWindow508Type.SimpleAccessibility] = {
        objects: objectWindowIDs.simpleAccessibility.objects
    };
    windows508Layers[MainMenuWindow508Type.AlertUI] = {
        objects: objectWindowIDs.alert.objects
    };
}

class MainMenuVideoCaching extends VideoSegmentItem {
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'bg-video',
				src: process.env.PUBLIC_URL + '/assets/videos/main-menu-bg/bs-bg-video.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const set508Window = (window: MainMenuWindow508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}

export const mainMenuVideoCaching = new MainMenuVideoCaching();

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

let isInitializing: boolean = false;

const MainMenuPage = (props: any) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	(window as any)['set-508-window-return-to-main-menu-on'] = () => {
		set508Window(MainMenuWindow508Type.ReturnToMainMenu);
	}
	(window as any)['set-508-window-return-to-main-menu-off'] = () => {
		updateLast508Window();
	}
	(window as any)['set-508-window-simple-accessibility-on'] = () => {
		set508Window(MainMenuWindow508Type.SimpleAccessibility);
	}
	(window as any)['set-508-window-simple-accessibility-off'] = () => {
		updateLast508Window();
	}
	(window as any)['ui-force-update'] = () => {
		setForceUpdate(!forceUpdate);
	}
	useEffect(() => {
		if(!isInitializing) {
			let url = new URL(window.location.href);
			let search_params = url.searchParams;
			let w: any = search_params.get('w');
			if(!w || w === PageType.MainMenu) {
				console.warn('init main menu page');
				let gm = new GameManager();
				gm.customData = {
					
				};
				let environment = new VideoEnvironment(gm, null);
				environment.init();
				gm.init([
					new Scenario1(gm, PageType.Scenario1.toString()),
					new Scenario2(gm, PageType.Scenario2.toString()),
					new Scenario3(gm, PageType.Scenario3.toString()),
					new Scenario4(gm, PageType.Scenario4.toString()),
					new Scenario5(gm, PageType.Scenario5.toString()),
				], environment, new JsxUIManager(gm), new ReactSoundManager(), true, '', {}, constants.debugMode);
			}
			isInitializing = true;
		}
	})
	return (
		<div className='main-menu-root' style={{
			position: 'relative',
			pointerEvents: 'all',
			width: '100%',
			height: '100%'
		}}>
			{/* <CoreLandingPage></CoreLandingPage> */}
			<video style={{
				position: 'absolute',
				width: '100%',
				height: '100%',
				top: '0',
				left: '0'
			}} src={mainMenuVideoCaching.getItemByKey('bg-video').src} playsInline={true} controls={false} loop={true}/>

			<MainMenuUI updateWindow={props.updateWindow} isInScenarios={props.isInScenarios} preCacheManager={props.preCacheManager}></MainMenuUI>
		</div>
	);
};

export interface SummativeSlot {
	slotIndex: number;
	scenarioNumber: number;
}

export default MainMenuPage;